// Contract Configuration
export const CONTRACT_ADDRESS = "0xE19285379A3969A3599Ba46C3D07F880b7CA0CD2";

// Network Configuration - opBNB Mainnet
export const NETWORK_CONFIG = {

  chainId: "0xCC", // 204 in decimal for opBNB Mainnet
  chainName: "opBNB Mainnet",
  nativeCurrency: {
    name: "BNB",
    symbol: "BNB",
    decimals: 18
  },
  rpcUrls: ["https://opbnb-mainnet-rpc.bnbchain.org"],
  blockExplorerUrls: ["https://opbnbscan.com/"]
}



// USDT Token Address (opBNB Mainnet)
export const USDT_ADDRESS = "0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3";

// Package Prices in USDT (with 18 decimals) - 8 Packages
export const PACKAGE_PRICES = [
  "10000000000000000000",    // 10 USDT - Neural Node
  "25000000000000000000",    // 25 USDT - Data Core
  "50000000000000000000",    // 50 USDT - AI Matrix
  "100000000000000000000",   // 100 USDT - Quantum Core
  "250000000000000000000",   // 250 USDT - Neural Network
  "500000000000000000000",   // 500 USDT - Deep Learning
  "1000000000000000000000",  // 1000 USDT - AGI System
  "2000000000000000000000"   // 2000 USDT - Superintelligence
];

export const PACKAGE_NAMES = [
  "NeuroCore - 10 USDT",
  "AlgoCore - 25 USDT",
  "IntelliCore - 50 USDT",
  "SynapCore - 100 USDT",
  "DeepCore - 250 USDT",
  "DataCore - 500 USDT",
  "MindCore - 1000 USDT",
  "QuantumCore - 2000 USDT"
];

export const DEFAULT_REFERRER = 100000;

// Contract ABI
export const CONTRACT_ABI = [
  // Events
  {
    "anonymous": false,
    "inputs": [
      {"indexed": true, "internalType": "uint256", "name": "userId", "type": "uint256"},
      {"indexed": true, "internalType": "uint256", "name": "referrerId", "type": "uint256"},
      {"indexed": false, "internalType": "address", "name": "account", "type": "address"}
    ],
    "name": "UserRegistered",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": true, "internalType": "uint256", "name": "userId", "type": "uint256"},
      {"indexed": true, "internalType": "uint256", "name": "packageId", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"}
    ],
    "name": "PackageActivated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": true, "internalType": "uint256", "name": "userId", "type": "uint256"},
      {"indexed": true, "internalType": "uint256", "name": "packageId", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"}
    ],
    "name": "PackageRetoppedUp",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": true, "internalType": "uint256", "name": "fromId", "type": "uint256"},
      {"indexed": true, "internalType": "uint256", "name": "toId", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "packageId", "type": "uint256"}
    ],
    "name": "DirectReferralIncome",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": true, "internalType": "uint256", "name": "fromId", "type": "uint256"},
      {"indexed": true, "internalType": "uint256", "name": "toId", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "level", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "packageId", "type": "uint256"}
    ],
    "name": "MatrixLevelIncome",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": true, "internalType": "uint256", "name": "fromId", "type": "uint256"},
      {"indexed": true, "internalType": "uint256", "name": "toId", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "level", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "packageId", "type": "uint256"}
    ],
    "name": "NormalLevelIncome",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": true, "internalType": "uint256", "name": "userId", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"}
    ],
    "name": "Claimed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": true, "internalType": "uint256", "name": "userId", "type": "uint256"},
      {"indexed": true, "internalType": "uint256", "name": "packageId", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"}
    ],
    "name": "PoolIncomeClaimed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": true, "internalType": "uint256", "name": "userId", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"}
    ],
    "name": "RoyaltyIncomeClaimed",
    "type": "event"
  },
  // Functions
  {
    "inputs": [{"internalType": "uint256", "name": "referrerId", "type": "uint256"}],
    "name": "register",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "packageId", "type": "uint256"}],
    "name": "upgradePackage",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "packageId", "type": "uint256"}],
    "name": "retopupPackage",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "claimAllIncome",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "claimIncome",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "packageId", "type": "uint256"}],
    "name": "claimPoolIncome",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "claimRoyaltyIncome",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "address", "name": "", "type": "address"}],
    "name": "addressToId",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "userId", "type": "uint256"}],
    "name": "getUserDetails",
    "outputs": [
      {"internalType": "address", "name": "account", "type": "address"},
      {"internalType": "uint256", "name": "id", "type": "uint256"},
      {"internalType": "uint256", "name": "referrer", "type": "uint256"},
      {"internalType": "bool", "name": "isActive", "type": "bool"},
      {"internalType": "uint256", "name": "totalDirectReferrals", "type": "uint256"},
      {"internalType": "uint256", "name": "claimableAmount", "type": "uint256"},
      {"internalType": "uint256", "name": "totalClaimed", "type": "uint256"},
      {"internalType": "uint256", "name": "totalIncome", "type": "uint256"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "userId", "type": "uint256"}],
    "name": "getUserPackages",
    "outputs": [{"internalType": "bool[8]", "name": "activePackages", "type": "bool[8]"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "uint256", "name": "userId", "type": "uint256"},
      {"internalType": "uint256", "name": "packageId", "type": "uint256"}
    ],
    "name": "getUserPackageDetails",
    "outputs": [
      {"internalType": "bool", "name": "isActive", "type": "bool"},
      {"internalType": "uint256", "name": "activationTime", "type": "uint256"},
      {"internalType": "uint256", "name": "totalInvested", "type": "uint256"},
      {"internalType": "uint256", "name": "totalEarned", "type": "uint256"},
      {"internalType": "uint256", "name": "ceilingLimit", "type": "uint256"},
      {"internalType": "uint256", "name": "remainingLimit", "type": "uint256"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "userId", "type": "uint256"}],
    "name": "getUserIncomeBreakdown",
    "outputs": [
      {"internalType": "uint256", "name": "directReferralIncome", "type": "uint256"},
      {"internalType": "uint256", "name": "matrixLevelIncome", "type": "uint256"},
      {"internalType": "uint256", "name": "normalLevelIncome", "type": "uint256"},
      {"internalType": "uint256", "name": "poolIncome", "type": "uint256"},
      {"internalType": "uint256", "name": "royaltyIncome", "type": "uint256"},
      {"internalType": "uint256", "name": "totalIncome", "type": "uint256"},
      {"internalType": "uint256", "name": "claimableAmount", "type": "uint256"},
      {"internalType": "uint256", "name": "totalClaimed", "type": "uint256"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "userId", "type": "uint256"}],
    "name": "getUserReferrals",
    "outputs": [{"internalType": "uint256[]", "name": "", "type": "uint256[]"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "uint256", "name": "userId", "type": "uint256"},
      {"internalType": "uint256", "name": "packageId", "type": "uint256"}
    ],
    "name": "getMatrixDetails",
    "outputs": [
      {"internalType": "uint256", "name": "upline", "type": "uint256"},
      {"internalType": "uint256[]", "name": "directDownlines", "type": "uint256[]"},
      {"internalType": "uint256", "name": "totalTeamSize", "type": "uint256"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "userId", "type": "uint256"}],
    "name": "getUserTotalClaimableIncome",
    "outputs": [
      {"internalType": "uint256", "name": "regularIncome", "type": "uint256"},
      {"internalType": "uint256", "name": "poolIncome", "type": "uint256"},
      {"internalType": "uint256", "name": "royaltyIncome", "type": "uint256"},
      {"internalType": "uint256", "name": "totalClaimable", "type": "uint256"}
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "uint256", "name": "userId", "type": "uint256"},
      {"internalType": "uint256", "name": "packageId", "type": "uint256"}
    ],
    "name": "getUserClaimablePoolIncome",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "uint256", "name": "", "type": "uint256"},
      {"internalType": "uint256", "name": "", "type": "uint256"}
    ],
    "name": "poolEligibility",
    "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "uint256", "name": "userId", "type": "uint256"},
      {"internalType": "uint256", "name": "packageId", "type": "uint256"},
      {"internalType": "uint256", "name": "level", "type": "uint256"}
    ],
    "name": "getMatrixLevelUsers",
    "outputs": [{"internalType": "uint256[]", "name": "", "type": "uint256[]"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "uint256", "name": "userId", "type": "uint256"},
      {"internalType": "uint256", "name": "packageId", "type": "uint256"},
      {"internalType": "uint256", "name": "level", "type": "uint256"}
    ],
    "name": "getNormalLevelUsers",
    "outputs": [{"internalType": "uint256[]", "name": "", "type": "uint256[]"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "uint256", "name": "userId", "type": "uint256"},
      {"internalType": "uint256", "name": "packageId", "type": "uint256"}
    ],
    "name": "getMatrixLevelCounts",
    "outputs": [{"internalType": "uint256[10]", "name": "levelCounts", "type": "uint256[10]"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "uint256", "name": "userId", "type": "uint256"},
      {"internalType": "uint256", "name": "packageId", "type": "uint256"}
    ],
    "name": "getNormalLevelCounts",
    "outputs": [{"internalType": "uint256[10]", "name": "counts", "type": "uint256[10]"}],
    "stateMutability": "view",
    "type": "function"
  }
];

// USDT ABI (ERC20 standard functions)
export const USDT_ABI = [
  {
    "constant": false,
    "inputs": [
      {"name": "_spender", "type": "address"},
      {"name": "_value", "type": "uint256"}
    ],
    "name": "approve",
    "outputs": [{"name": "", "type": "bool"}],
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {"name": "_owner", "type": "address"},
      {"name": "_spender", "type": "address"}
    ],
    "name": "allowance",
    "outputs": [{"name": "", "type": "uint256"}],
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [{"name": "_owner", "type": "address"}],
    "name": "balanceOf",
    "outputs": [{"name": "balance", "type": "uint256"}],
    "type": "function"
  }
];